import { render, staticRenderFns } from "./ArrearsPosting.vue?vue&type=template&id=3f5f819f"
import script from "./ArrearsPosting.vue?vue&type=script&lang=js"
export * from "./ArrearsPosting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports